export const isPageLoaderActive = (state) => state.pageLoader.pageLoaderIsActive
